// extracted by mini-css-extract-plugin
module.exports = {"mapMarker":"Marker_mapMarker__2e_xm","mapMarkerWhiteBorder":"Marker_mapMarkerWhiteBorder__3awIj"};